import cookie from 'js-cookie'

const COOKIE_NAME = 'coaching-auth-token'

/**
 * Save auth token as cookie
 * @param {String} token Auth token
 */
function set (token) {
  cookie.set(COOKIE_NAME, token, { expires: 30 })
}

/**
 * Get auth token from cookies
 * @returns {String} Auth token
 */
function get () {
  return cookie.get(COOKIE_NAME)
}

/**
 * Remove auth token from cookies
 */
function remove () {
  cookie.remove(COOKIE_NAME)
}

export default {
  set,
  get,
  remove
}
